import { Injectable, ComponentRef, forwardRef, Provider } from '@angular/core';
import { IProductAddToCartTemplateDialogService, IProductAddToCartTemplateDialogServiceToken } from 'projects/shared/lib/interfaces/services/dialogs/product-add-to-cart-template-dialog-service.abstract';
import { ShoppingCartDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { DialogBaseService } from 'projects/shared/lib/services/ui/dialog.service';
import { ProductAddToCartListDialogComponent } from '../../components/shared/dialog/product-add-to-cart-list-dialog/product-add-to-cart-list-dialog.component';

@Injectable({
  providedIn: 'root',
}) export class ProductAddToCartTemplateDialogService implements IProductAddToCartTemplateDialogService {

  productAddToCartTemplateDialogShow(
    callbackCancel: () => void,
    callbackYes: (cartTemplate: ShoppingCartDto) => void,
  ) {
    DialogBaseService.dialogGenericShow(
      ProductAddToCartListDialogComponent,
      (component: ComponentRef<ProductAddToCartListDialogComponent>) => {
        component.instance.modalCancel.subscribe(
          () => {
            callbackCancel();
            DialogBaseService.dynamicComponentRemove(component);
          }
        );

        component.instance.modalYes.subscribe(
          (cartTemplate: ShoppingCartDto) => {
            callbackYes(cartTemplate);
            DialogBaseService.dynamicComponentRemove(component);
          }
        );
      }
    );
  }

}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ProductAddToCartTemplateDialogMHServiceProvider: Provider[] = [
  { provide: IProductAddToCartTemplateDialogServiceToken, useExisting: forwardRef(() => ProductAddToCartTemplateDialogService) }
];
